import logoPhenix295 from '../../assets/images/partners/phenix295/logo.png'
import logoPhenix295Light from '../../assets/images/partners/phenix295/logo-light.png'
import logoPhenix295QR from '../../assets/images/partners/phenix295/qr.jpg'
import logoPhenixCover from '../../assets/images/partners/phenix295/cover.png'

/*Phenix168*/
import logoPhenix168 from '../../assets/images/partners/phenix168/logo.png'
import logoPhenix168Light from '../../assets/images/partners/phenix168/logo-light.png'
import logoPhenix168QR from '../../assets/images/partners/phenix168/qr.jpg'
import logoPhenix168Cover from '../../assets/images/partners/phenix168/cover.png'

/*UFO*/
import logoUfo98 from '../../assets/images/logos/ufo98.png'
import logoUfo98Light from '../../assets/images/partners/ufo98/logo-light.png'
import logoUfo98QR from '../../assets/images/partners/ufo98/qr.jpg'
import logoUfo98Cover from '../../assets/images/partners/ufo98/cover.png'

/*VIPACLUB*/
import logoVipaclub from '../../assets/images/partners/vipaclub/logo.png'
import logoVipaclubLight from '../../assets/images/partners/vipaclub/logo-light.png'
import logoVipaclubQR from '../../assets/images/partners/vipaclub/qr.jpg'
import logoVipaclubCover from '../../assets/images/partners/vipaclub/cover.png'


/*OCTA8888*/
import logoOcta from '../../assets/images/partners/octa8888/logo.png'
import logoOctaLight from '../../assets/images/partners/octa8888/logo-light.png'
import logoOctaQR from '../../assets/images/partners/octa8888/qr.jpg'
import logoOctaCover from '../../assets/images/partners/octa8888/cover.png'


/*Dragon168*/
import logoDragon from '../../assets/images/partners/dragon168/logo.png'
import logoDragonLight from '../../assets/images/partners/dragon168/logo-light.png'
import logoDragonQR from '../../assets/images/partners/dragon168/qr.jpg'
import logoDragonCover from '../../assets/images/partners/dragon168/cover.png'

/*Lion168*/
import logoLionImg from '../../assets/images/partners/lion168/logo.png'
import logoLionLight from '../../assets/images/partners/lion168/logo-light.png'
import logoLionQR from '../../assets/images/partners/lion168/qr.jpg'
import logoLionCover from '../../assets/images/partners/lion168/cover.png'

/*SG168*/
import logoImgSg168 from '../../assets/images/partners/sgaming/logo.png'
import logoLightSg168 from '../../assets/images/partners/sgaming/logo-light.png'
import logoQRSg168 from '../../assets/images/partners/sgaming/qr.jpg'
import logoCoverSg168 from '../../assets/images/partners/sgaming/cover.png'


/*AXE888*/
import logoImgAxe from '../../assets/images/partners/axe888/logo.png'
import logoLightAxe from '../../assets/images/partners/axe888/logo-light.png'
import logoQRAxe from '../../assets/images/partners/axe888/qr.jpg'
import logoCoverAxe from '../../assets/images/partners/axe888/cover.png'

/*Wishdom*/
import logoImgW from '../../assets/images/partners/wishdom/logo.png'
import logoLightW from '../../assets/images/partners/wishdom/logo-light.png'
import logoQRW from '../../assets/images/partners/wishdom/qr.jpg'
import logoCoverW from '../../assets/images/partners/wishdom/cover.png'

/*PKLAOS88*/
import logoImgPklaos from '../../assets/images/partners/pklaos88/logo.png'
import logoLightPklaos from '../../assets/images/partners/pklaos88/logo-light.png'
import logoQRPklaos from '../../assets/images/partners/pklaos88/qr.jpg'
import logoCoverPklaos from '../../assets/images/partners/pklaos88/cover.png'

const Logos = {
    phenix: {
        normal: logoPhenix295,
        light: logoPhenix295Light,
        qrcode: logoPhenix295QR,
        cover: logoPhenixCover
    },
    phenix168: {
        normal: logoPhenix168,
        light: logoPhenix168Light,
        qrcode: logoPhenix168QR,
        cover: logoPhenix168Cover
    },
    ufo98: {
        normal: logoUfo98,
        light: logoUfo98Light,
        qrcode: logoUfo98QR,
        cover: logoUfo98Cover
    },
    vipaclub: {
        normal: logoVipaclub,
        light: logoVipaclubLight,
        qrcode: logoVipaclubQR,
        cover: logoVipaclubCover
    },
    octa8888: {
        normal: logoOcta,
        light: logoOctaLight,
        qrcode: logoOctaQR,
        cover: logoOctaCover
    },
    dragon: {
        normal: logoDragon,
        light: logoDragonLight,
        qrcode: logoDragonQR,
        cover: logoDragonCover
    },
    lion: {
        normal: logoLionImg,
        light: logoLionLight,
        qrcode: logoLionQR,
        cover: logoLionCover
    },
    sg168: {
        normal: logoImgSg168,
        light: logoLightSg168,
        qrcode: logoQRSg168,
        cover: logoCoverSg168
    },
    axe888: {
        normal: logoImgAxe,
        light: logoLightAxe,
        qrcode: logoQRAxe,
        cover: logoCoverAxe
    },
    wishdom: {
        normal: logoImgW,
        light: logoLightW,
        qrcode: logoQRW,
        cover: logoCoverW
    }
    ,
    pklaos88: {
        normal: logoImgPklaos,
        light: logoLightPklaos,
        qrcode: logoQRPklaos,
        cover: logoCoverPklaos
    }
}

export default Logos
